import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ILeadSource } from "../leadsourceModel";

export const getAllLeadSource = createAsyncThunk(
  "InquirySources/FindAllInquirySources",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/InquirySources/FindAllInquirySources`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching LeadStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveLeadSource = createAsyncThunk(
  "InquirySources/FindAllActiveInquirySources",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/InquirySources/FindAllActiveInquirySources`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching LeadSource:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createLeadSource = createAsyncThunk(
  "InquirySources/InsertInquirySources",
  async (LeadSourceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InquirySources/InsertInquirySources`,
        LeadSourceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating LeadSource:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateLeadSource = createAsyncThunk(
  "InquirySources/UpdateInquirySources",
  async (LeadSourceData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InquirySources/UpdateInquirySources`,
        LeadSourceData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating LeadSource:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getLeadSourceByID = createAsyncThunk(
  "InquirySources/FindByIDInquirySources",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/InquirySources/FindByIDInquirySources?ID=${ID}`
      );

      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        Source: result?.Source,
        IsActive: result?.IsActive ? 1 : 2,
      } as ILeadSource;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching LeadSource:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const leadsourceActiveInactive = createAsyncThunk(
  "InquirySources/ActiveInActiveInquirySources",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InquirySources/ActiveInActiveInquirySources`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Lead Source:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteLeadSource = createAsyncThunk(
  "InquirySources/DeleteInquirySources",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/InquirySources/DeleteInquirySources`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting LeadSource:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
